<div class="d-flex flex-column h-100">
  <div class="d-flex justify-content-between p-3 form-density-2">
    <h2 class="d-flex align-items-center mat-headline-6 mb-0">
      {{ item?.description | translate }}
      <span class="mat-caption pl-3">
        {{ item?.inventory | translate }}
      </span>
    </h2>

    <div>
      @if (dialogData) {
        <button mat-icon-button (click)="dialogData.isZoom = !dialogData.isZoom">
          @if (!dialogData.isZoom) {
            <mat-icon>zoom_out_map</mat-icon>
          }
          @if (dialogData.isZoom) {
            <mat-icon>zoom_in_map</mat-icon>
          }
        </button>
      }
      <button mat-icon-button [disabled]="buttonsDisabled" class="ml-3" (click)="onLoadPreviousItem()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button mat-icon-button [disabled]="buttonsDisabled" (click)="onLoadNextItem()">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <button mat-icon-button class="ml-3" (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="p-0" [ngClass]="{ zoom: dialogData?.isZoom }">
    @if (storeService.store.selectedItem) {
      <mpa-item-details [isZoom]="dialogData?.isZoom" [isReadOnly]="isReadOnly"></mpa-item-details>
    }
  </mat-dialog-content>

  @if (!dialogData.isZoom) {
    <mat-dialog-actions class="border-top justify-content-between">
      @if (!dialogData.isZoom) {
        <div class="col-auto">
          <button mat-stroked-button class="mr-3 text-uppercase" (click)="onPrint(ePrintType.DETAILS)">
            {{ 'ITEM.DETAIL.PRINT_CARD' | translate }}
          </button>
          <button mat-stroked-button class="text-uppercase" (click)="onPrint(ePrintType.LABEL)">
            {{ 'ITEM.DETAIL.PRINT_LABEL' | translate }}
          </button>
        </div>
        <div class="col-auto">
          @if (
            !isReadOnly &&
            (uiRoleManagerService.canI(eRoleActions.EDIT_ITEM) ||
              uiRoleManagerService.canI(eRoleActions.EDIT_VALUE)) &&
            itemDetailsComponent?.isItemFormsTab
          ) {
            <button mat-flat-button color="primary" class="text-uppercase" (click)="onSave()">
              {{ 'ITEM.DETAIL.SAVE_CHANGES' | translate }}
            </button>
          }
        </div>
      }
    </mat-dialog-actions>
  }
</div>
